import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as authApi from '../api/auth';

// Explicit migration: old browser bearer credentials must not survive.
localStorage.removeItem('token');
localStorage.removeItem('refreshToken');
export const loginAsync = createAsyncThunk('auth/login', async ({ email, password }, { rejectWithValue }) => {
  try { return (await authApi.login(email, password)).data.user; }
  catch (err) { return rejectWithValue(err.response?.data?.detail || 'Accesso non riuscito'); }
});
export const acceptInviteAsync = createAsyncThunk('auth/acceptInvite',
  async ({ token, password, passwordConfirm }, { rejectWithValue }) => {
    try { return (await authApi.acceptInvitation(token, password, passwordConfirm)).data.user; }
    catch (err) { return rejectWithValue(err.response?.data?.detail || 'Non è stato possibile usare il link.'); }
  });
export const loadUser = createAsyncThunk('auth/loadUser', async () => (await authApi.getMe()).data);
export const logout = createAsyncThunk('auth/logout', async () => {
  await authApi.logout();
  // Clears component caches and in-flight requests as well as Redux.
  window.location.assign('/login');
});
const authSlice = createSlice({
  name: 'auth',
  initialState: { user: null, isAuthenticated: false, loading: true, error: null },
  reducers: { clearError(state) { state.error = null; } },
  extraReducers: builder => {
    for (const action of [loginAsync, acceptInviteAsync, loadUser]) {
      builder.addCase(action.pending, state => { state.loading = true; state.error = null; });
      builder.addCase(action.fulfilled, (state, { payload }) => {
        state.loading = false; state.user = payload; state.isAuthenticated = true;
      });
      builder.addCase(action.rejected, (state, { payload }) => {
        state.loading = false; state.user = null; state.isAuthenticated = false; state.error = payload || null;
      });
    }
    builder.addCase(logout.fulfilled, state => {
      state.user = null; state.isAuthenticated = false; state.loading = false;
    });
    builder.addCase(logout.rejected, state => { state.error = 'Disconnessione non riuscita. Riprova.'; });
  },
});
export const { clearError } = authSlice.actions;
export default authSlice.reducer;
